module.exports = __webpack_public_path__ + "img/ill-home-skills-creative-team.2864419b.svg";